import React from 'react';
import Navbar from '../../components/Navbar';
import SegmAnnoLabelCreate from '../../components/SegmAnnoLabel/SegmAnnoLabelCreate';
import './SegmAnnoLabelCreatePage.css';

const SegmAnnoLabelCreatePage = () => {
  return (
    <div className="segm-anno-label-create-page">
      <Navbar />
      <div className="segm-anno-label-create-content">
        <h2>New SegmAnno Label</h2>
        <SegmAnnoLabelCreate />
      </div>
    </div>
  );
};

export default SegmAnnoLabelCreatePage;
